import { styled, useTheme } from '@mui/material/styles';
import { Box, Toolbar } from '@mui/material';
import { CssBaseline, AppBar } from '@mui/material';
import Header from './Header';
import { Outlet } from 'react-router-dom';

const Main = styled('main')(({ theme }) => ({
    ...theme.typography.cleanPageContent,
    [theme.breakpoints.up('md')]: {
        marginLeft: '50px',
        marginRight: '50px',
        marginBottom: '50px',
        marginTop: '65px',
    },
    [theme.breakpoints.down('md')]: {
        marginLeft: '25px',
        marginRight: '25px',
        marginTop: '40px',
    },
    [theme.breakpoints.down('sm')]: {
        marginLeft: '10px',
        marginRight: '10px',
        marginTop: '25px',
    }
}));

const CleanLayout = () => {
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex'}}>
            <CssBaseline />

            <AppBar
                enableColorOnDark
                position='fixed'
                color='inherit'
                elevation={0}
                sx={{
                    bgcolor: theme.palette.background.default,
                }}
            >
                <Toolbar>
                    <Header />
                </Toolbar>
            </AppBar>

            <Main theme={theme}>
                <Outlet />
            </Main>
        </Box>
    );
};

export default CleanLayout;